// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"7655":"1c2f0fd5b8d115f2","9038":"d1cf0a68109722fa"}[chunkId] + ".js";
};